var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ErrorDialog',{attrs:{"text":_vm.error === null ? 'N/A' : _vm.error.text,"is-open":_vm.error,"dialog-model":_vm.dialogModel},on:{"close":_vm.clearLastModuleError,"ok":_vm.clearLastModuleError}})}
var staticRenderFns = []

export { render, staticRenderFns }